import axios from "axios";
import { apiUrl } from "features/configure";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

export default function useGetXChart() {
  const { campaignId, sharedEntityName } = useParams();
  const outletContext = useOutletContext();
  const entityName = sharedEntityName || outletContext?.[0];
  const [data, setData] = useState({
    chartData: [],
    diffData: [],
    total: {
      impressions: {
        count: 0,
        growth: 0,
      },
      likes: {
        count: 0,
        growth: 0,
      },
      comments: {
        count: 0,
        growth: 0,
      },
      reposts: {
        count: 0,
        growth: 0,
      },
    },
  });
  const [day, setDay] = useState("7");
  const [link, setLink] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const dispatchSnackbar = useDispatchSnackbar();
  const getChatData = async () => {
    try {
      setIsLoading(true);
      const endpoint = sharedEntityName
        ? `api/x/shared/${entityName}/campaign/${campaignId}/performance`
        : `api/x/${entityName}/campaign/${campaignId}/performance`;

      const { data } = await axios(
        `${apiUrl}/${endpoint}?${
          Object.keys(link).length > 0 ? `link=${link.links}&` : ""
        }${day ? `interval=${day}` : ""}`
      );
      setData(data);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getChatData();
  }, [link, day]);

  return {
    data,
    link,
    day,
    setLink,
    setDay,
    isLoading,
  };
}
